import {
  BULLET_PATTERNS_HTML,
  ALL_ORDERED_LIST_PATTERNS,
} from '../bulletPatterns.js';

/**
 * Converts bullet-prefixed paragraphs to HTML unordered lists
 */
export class BulletListConverter {
  convertHyphenListsToHtml(container) {
    const paragraphs = Array.from(container.querySelectorAll('p'));
    let currentListItems = [];
    let currentList = null;

    const bulletPatterns = BULLET_PATTERNS_HTML;

    paragraphs.forEach((p) => {
      const textContent = p.textContent || '';
      const trimmedText = textContent.trim();

      const matchedPattern = bulletPatterns.find((pattern) =>
        pattern.regex.test(trimmedText),
      );

      if (matchedPattern) {
        const listItemText = trimmedText.substring(matchedPattern.length);

        if (!currentList) {
          currentList = document.createElement('ul');
          p.parentNode.insertBefore(currentList, p);
        }

        const li = document.createElement('li');
        li.textContent = listItemText;

        const spans = p.querySelectorAll('span, strong, em, b, i');
        if (spans.length > 0) {
          li.innerHTML = p.innerHTML.replace(matchedPattern.regex, '');
        }

        currentList.appendChild(li);
        currentListItems.push(p);
      } else {
        if (currentList) {
          currentListItems.forEach((item) => item.remove());
          currentListItems = [];
          currentList = null;
        }
      }
    });

    if (currentList && currentListItems.length > 0) {
      currentListItems.forEach((item) => item.remove());
    }
  }
}

/**
 * Converts numbered paragraphs to HTML ordered lists
 */
export class NumberedListConverter {
  convertNumberedListsToHtml(container) {
    const paragraphs = Array.from(container.querySelectorAll('p'));
    let currentListItems = [];
    let currentList = null;
    let expectedNumber = 1;

    const orderedPatterns = ALL_ORDERED_LIST_PATTERNS;

    paragraphs.forEach((p) => {
      const textContent = p.textContent || '';
      const trimmedText = textContent.trim();

      const matchedPattern = orderedPatterns.find((pattern) => {
        return pattern.regex.test(trimmedText);
      });

      if (matchedPattern) {
        const numberMatch = trimmedText.match(/^(\d+)/);
        const currentNumber = numberMatch ? parseInt(numberMatch[1], 10) : null;
        const isSequential = currentNumber === expectedNumber;
        const isStartOfNewList = currentNumber === 1;

        if (isSequential || (isStartOfNewList && !currentList)) {
          let listItemText = trimmedText.replace(matchedPattern.regex, '');

          if (!currentList) {
            currentList = document.createElement('ol');
            p.parentNode.insertBefore(currentList, p);
            expectedNumber = currentNumber;
          }

          const li = document.createElement('li');
          li.textContent = listItemText;

          const spans = p.querySelectorAll('span, strong, em, b, i');
          if (spans.length > 0) {
            li.innerHTML = p.innerHTML.replace(matchedPattern.regex, '');
          }

          currentList.appendChild(li);
          currentListItems.push(p);
          expectedNumber++;
        } else {
          if (currentList) {
            currentListItems.forEach((item) => item.remove());
            currentListItems = [];
            currentList = null;
            expectedNumber = 1;
          }
        }
      } else {
        if (currentList) {
          currentListItems.forEach((item) => item.remove());
          currentListItems = [];
          currentList = null;
          expectedNumber = 1;
        }
      }
    });

    if (currentList && currentListItems.length > 0) {
      currentListItems.forEach((item) => item.remove());
    }
  }
}
